// =============================================================================
//
// @file application.js
// All subtheme Drupal behaviours
//
// =============================================================================

/*------------------------------------------------------------------------------
 [Table of contents]
 1. Mobile navigation
 2. Sticky menu
 3. Audio player
 4. Read more paragraph
 5. Smooth scroll
 6. Slick
 7. Video
 9. Story tags
 10. Match height
 11. Print Story
 12. Animate Lottifiles on hover
 13. Quote quotes
 14. Image animation (when image in viewport)
 15. Logo animation
 16. View filters
 17. Glossary
 18. What's new slider
 19. Partnerships slider
 20. Cookies module changes
 21. Events load more
 -----------------------------------------------------------------------------*/
(function ($) {
  "use strict";

  /*----------------------------------------
    X. Hello World
   ------------------------------------------
    Description...
   ----------------------------------------*/
  Drupal.behaviors.helloWorld = {
    attach: function (context, settings) {
      // More info on once changes - https://www.drupal.org/node/3158256.
      // This is working.
      // if (once('coreHelloWorld', 'html').length) {
      //   $('.target', context).each(function () {
      //     $(this).toggleClass('expanded');
      //   });
      // }
      // $(once('coreHelloWorld', 'body')).on();
      // if (once('coreHelloWorld', 'html').length) {
      //   $(document).on();
      // }
      // This didn't work everytime.
      // $(once('coreHelloWorld', 'table', context)).each(function () {
      //   console.log('Core Hello World');
      // });
    },
  };

  // Function for when element comes into view.
  // Used for sticky menu and starting slick autoplay.
  // https://gist.github.com/EvanHerman/a1045c19e115edc18b12
  function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
      return;
    }
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;

    return (
      (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height &&
        top <= viewport_top &&
        bottom >= viewport_bottom)
    );
  }

  /*-----------------------------------------
    1. Mobile navigation
   ----------------------------------------*/
  Drupal.behaviors.mobileNavigation = {
    attach: function (context, settings) {
      // Menu fade in on page load.
      $(window).on("load", function () {
        $("#menu-bar", context).addClass("is-loaded");
        $(".branding", context).addClass("is-loaded");
        $(".hero-background", context).addClass("is-loaded");
      });

      // Menu toggle.
      var $menuToggle = $("#menu-toggle", context);
      if (once("mobileNavigation", $menuToggle).length) {
        $menuToggle.on("click", function (event) {
          event.preventDefault();
          // Toggle menu burger
          $(this).toggleClass("expanded");
          // Toggle menu popup
          $("body").toggleClass("menu-open");
        });
      }

      // When user clicks on newsletter Subscribe.
      $(".nav-newsletter .cta").on("click", function (event) {
        $menuToggle.removeClass("expanded");
        $("body").removeClass("menu-open");
        Drupal.behaviors.coreSmoothScroll.smoothScroll(
          $(this),
          500,
          context,
          settings,
          1000
        );
        $("#newsletter .form-item input").focus();
      });
    },
  };

  /*-----------------------------------------
    2. Sticky menu
   ----------------------------------------*/
  Drupal.behaviors.stickyMenu = {
    attach: function (context, settings) {
      // Hide sticky menu when footer comes into view.
      window.addEventListener("scroll", function (e) {
        if (isOnScreen($(".layout-footer"))) {
          $(".menu-bar", context).addClass("is-hidden");
        } else {
          $(".menu-bar", context).removeClass("is-hidden");
        }
      });
    },
  };

  /*-----------------------------------------
    3. Audio player
   ----------------------------------------*/
  Drupal.behaviors.audioPlyr = {
    attach: function (context, settings) {
      var player = new Plyr(".media--type-podcast audio", {
        controls: ["play", "progress", "current-time"],
        speed: {
          selected: 1,
          options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
        },
      });
    },
  };

  /*-----------------------------------------
    4. Read more paragraph
   ----------------------------------------*/
  Drupal.behaviors.readMoreParagraph = {
    attach: function (context, settings) {
      $(".paragraph--type--read-more", context).on("click", function () {
        $(this)
          .toggleClass("is-open")
          .find(".field--name-field-read-more-text")
          .slideToggle();
      });
    },
  };

  /*-----------------------------------------
    5. Smooth scroll
   ----------------------------------------*/
  Drupal.behaviors.smoothScroll = {
    attach: function (context, settings) {
      Drupal.behaviors.coreSmoothScroll.smoothScroll(
        ".paragraph-settings-wrapper--type--anchors .field--name-field-links a",
        500,
        context,
        settings,
        0,
        60,
        0,
        true
      );
    },
  };

  /*-----------------------------------------
    6. Slick
   ----------------------------------------*/
  Drupal.behaviors.slick = {
    attach: function (context, settings) {
      var maxDotsMobile = 8; // Up to 767px.
      var maxDotsTablet = 14; // 768px to 991px.
      var maxDotsDesktop = 20; // 992px and up.

      function getMaxDots() {
        var width = window.innerWidth;
        if (width < 768) return maxDotsMobile;
        if (width < 992) return maxDotsTablet;
        return maxDotsDesktop;
      }

      function updateVisibleDots($this, currentSlide) {
        var $dots = $this.find(".slick-dots li");
        var totalDots = $dots.length;
        var maxDots = getMaxDots();

        var start = Math.max(
          0,
          Math.min(currentSlide - Math.floor(maxDots / 2), totalDots - maxDots)
        );
        $dots
          .hide()
          .slice(start, start + maxDots)
          .show();
      }

      var $gallerySlick = $(
        ".paragraph--type--gallery .field--name-field-images",
        context
      );

      $(once("slick", $gallerySlick, context)).each(function () {
        var $this = $(this);

        $this.on(
          "init reInit beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            updateVisibleDots($this, nextSlide || 0);
          }
        );

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
          autoplay: true,
        });

        $(window).on("resize", function () {
          var slick = $this.slick("getSlick");
          updateVisibleDots($this, slick.currentSlide);
        });
      });
    },
  };

  /*-----------------------------------------
    7. Video
   ----------------------------------------*/
  Drupal.behaviors.videos = {
    attach: function (context, settings) {
      $(window).on("load", function () {
        $(once("videos", ".paragraph--type--video", context)).each(function () {
          var $this = $(this),
            iframe = $this.find("iframe"),
            source = iframe.attr("src"),
            externalVideo = false;

          if (source) {
            externalVideo = true;
          }

          $this
            .find(".field--name-field-media-image, .btn-play")
            .on("click", function () {
              if (externalVideo) {
                if (source.indexOf("vimeo") >= 0) {
                  var vimeoPlayer = new Vimeo.Player(iframe);
                  vimeoPlayer.play();
                } else if (source.indexOf("youtube") >= 0) {
                  iframe[0].src += "?autoplay=1";
                }
              } else {
                $this.find("video")[0].play();
              }

              $(this).parents(".page-content").addClass("is-active");
            });
        });
      });
    },
  };

  /*-----------------------------------------
    9. Story tags
   ----------------------------------------*/
  Drupal.behaviors.storyTags = {
    attach: function (context, settings) {
      var $storyNode = $(".node--view-mode-full.node--type-story", context);
      if (once("storyTags", ".show-all-tags").length) {
        $(".show-all-tags", context).on("click", function (e) {
          $storyNode.find(".tags-hidden").slideToggle();
          $(this).fadeOut();
        });
      }
    },
  };

  /*-----------------------------------------
    10. Match height
   ----------------------------------------*/
  Drupal.behaviors.matchHeight = {
    attach: function (context, settings) {
      var $element =
        ".paragraph--type--columns .field--name-field-sections > .field__item > .paragraph-settings-wrapper > .content-wrapper > .paragraph-wrapper > .paragraph--type--text";
      if (once("matchHeight", $element).length) {
        $($element, context).matchHeight({
          byRow: true,
        });
      }
    },
  };

  /*-----------------------------------------
    11. Print Story
   ----------------------------------------*/
  Drupal.behaviors.printStory = {
    attach: function (context, settings) {
      $(".print-story", context).on("click", function (e) {
        window.print();
      });
    },
  };

  /*-----------------------------------------
    12. Animate Lottifiles on hover
   ----------------------------------------*/
  Drupal.behaviors.lottifiles = {
    attach: function (context, settings) {
      var anim = {};

      $(once("lottifiles", ".lottie", context)).each(function () {
        var $this = $(this),
          lottieContainer = $this[0];

        // Define animation.
        var params = {
          container: lottieContainer,
          renderer: "svg",
          loop: false,
          autoplay: false,
          rendererSettings: {
            progressiveLoad: false,
          },
          path: $this.attr("data-lottie-json"),
        };

        // Load animation.
        anim[$this.attr("data-node-id")] = lottie.loadAnimation(params);

        // Play/stop animation when hovering over selected element.
        $(
          ".node--view-mode-teaser.node--type-pillar .teaser-wr .teaser-url",
          context
        )
          .on("mouseenter", function () {
            anim[$(this).parent().find(".lottie").attr("data-node-id")].play();
          })
          .on("mouseleave", function () {
            anim[$(this).parent().find(".lottie").attr("data-node-id")].stop();
          });
      });
    },
  };

  /*-----------------------------------------
    13. Quote quotes
   ----------------------------------------*/
  Drupal.behaviors.quoteQuotes = {
    attach: function (context, settings) {
      $(
        once(
          "quoteQuotes",
          ".paragraph--type--quote .field--name-field-body",
          context
        )
      ).each(function () {
        $(this).find("p:first-child").prepend('"');
        $(this).find("p:last-child").append('"');
      });
    },
  };

  /*-----------------------------------------
    14. Image animation (when image in viewport)
   ------------------------------------------
    This code add/removes the show class of the
    image when it is in the viewport.
  ----------------------------------------*/
  Drupal.behaviors.imgEffect = {
    attach: function (context, settings) {
      var elementInViewport = function (el, cb) {
        this.$el = $(el);
        this.cb = cb;
        this.watch();
        return this;
      };

      elementInViewport.prototype = {
        // Checks if the element is in.
        isIn: function isIn() {
          var _self = this;
          var $win = $(window);
          var elementTop = _self.$el.offset().top;
          var elementBottom = elementTop + _self.$el.outerHeight();
          var viewportTop = $win.scrollTop();
          var viewportBottom = viewportTop + $win.height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
        },

        // Launch a callback indicating when the element is in and when is out.
        watch: function () {
          var _self = this;
          var _isIn = false;

          function indicateInAndOut() {
            if (_self.isIn() && _isIn === false) {
              _self.cb.call(_self.$el, "entered");
              _isIn = true;
            }

            if (_isIn === true && !_self.isIn()) {
              _self.cb.call(_self.$el, "leaved");
              _isIn = false;
            }
          }

          $(window).on("resize scroll", function () {
            setTimeout(indicateInAndOut, 100);
          });
          $(window).on("load", function () {
            setTimeout(indicateInAndOut, 100);
          });
        },
      };

      // jQuery plugin.
      $.fn.isInViewport = function (cb) {
        return this.each(function () {
          var $element = $(this);
          var data = $element.data("isInViewport");
          if (!data) {
            $element.data("isInViewport", new elementInViewport(this, cb));
          }
        });
      };

      // Call the function isInViewport.
      $(
        ".node--view-mode-teaser," +
          ".block-views-blockprojects-map-map," +
          ".block-views-blockpartners-map-map," +
          ".view-filters," +
          ".paragraph-settings-wrapper--type--block .field--name-field-link," +
          ".paragraph-settings-wrapper--type--text-with-image .page-row," +
          ".paragraph-settings-wrapper--type--text-with-image h3," +
          ".hero.has-image .node-title," +
          ".hero.has-image .field--name-field-subtitle," +
          ".block-views-blockpillars-all," +
          ".hero.has-image .project-subtitle," +
          ".hero.has-image .hero__introduction," +
          ".hero.has-image .partner-subtitle," +
          ".paragraph--type--facts .field--name-field-title," +
          ".paragraph-settings-wrapper--type--related-content .field--name-field-title"
      ).isInViewport(function (status) {
        if (status === "entered") {
          // Do something when the images are in the viewport.
          $(this).addClass("viewport-show");
        }
        if (status === "leaved") {
          // Do something when the images leave the viewport.
          // $(this).removeClass('show');
        }
      });
    },
  };

  /*-----------------------------------------
    15. Logo animation
   ----------------------------------------*/
  Drupal.behaviors.logoAnimation = {
    attach: function (context, settings) {
      var darkZones = [];
      var $logo = $(".branding");
      var $logoLight = $logo.find(".logo-white");
      var $logoDark = $logo.find(".logo-purple");
      var logoHeight = $logo.outerHeight();
      var logoPositionTop = $logo.position().top;

      $(".bg-branding-dark").each(function (el) {
        var $this = $(this);
        var darkZone = {
          el: $this,
          top: $this.offset().top,
          bottom: $this.offset().top + $this.outerHeight(),
        };

        darkZones.push(darkZone);
      });

      $(window).scroll(function () {
        var scrollPos = $(document).scrollTop();
        var logoOffsetTop = scrollPos + logoPositionTop;
        var logoOffsetBottom = scrollPos + logoHeight + logoPositionTop;
        var logoSlide = 0;
        var isDark = true;
        var logoOffsetFromZone;

        $.each(darkZones, function (i, zone) {
          if (logoOffsetBottom > zone.bottom) {
            logoSlide = 0;
          } else if (
            logoOffsetBottom > zone.top &&
            logoOffsetBottom < zone.bottom
          ) {
            logoSlide = logoHeight;
          }
        });

        $logoLight.css("bottom", logoHeight - logoSlide);
        $logoDark.css("top", logoSlide);
      });
    },
  };

  /*-----------------------------------------
    16. View filters
   ----------------------------------------*/
  Drupal.behaviors.viewFilters = {
    attach: function (context, settings) {
      // Move form actions before search field.
      var $filterActions = $(".view-filters .form-actions");
      if (once("viewFilters", $filterActions).length) {
        $filterActions.insertBefore(
          ".view-filters .form-item-search, .view-filters .form-item-combine"
        );

        // Add class to body if filters are active. This is to show/hide reset button.
        if (window.location.href.indexOf("?") > -1) {
          $("body").addClass("filter-show-reset");
        } else {
          $("body").removeClass("filter-show-reset");
        }
      }

      $(
        once("filters-ready", "form.views-exposed-form .form-type-select")
      ).each(function () {
        $(this)
          .find("select")
          .on("change", function () {
            $(this).closest("form").find('.form-submit[value="Apply"]').click();
          });
      });
    },
  };

  /*-----------------------------------------
    17. Glossary
   ----------------------------------------*/
  Drupal.behaviors.jbfnGlossary = {
    attach: function (context, settings) {
      if ($(".glossary-filters-wr").length > 0) {
        // Filters become fixed when scrolled to.
        var filtersTop = $(".glossary-filters-wr").offset().top,
          glossaryBottom =
            $(".view-glossary.view-display-id-glossary").offset().top +
            $(".view-glossary.view-display-id-glossary").outerHeight() -
            $(".glossary-filters-wr").outerHeight();

        $(window).scroll(function () {
          var currentScroll = $(window).scrollTop();

          glossaryBottom =
            $(".view-glossary.view-display-id-glossary").offset().top +
            $(".view-glossary.view-display-id-glossary").outerHeight() -
            $(".glossary-filters-wr").outerHeight();

          if (currentScroll >= filtersTop) {
            $(".glossary-filters-wr").addClass("is-fixed");
          } else {
            $(".glossary-filters-wr").removeClass("is-fixed");
          }

          if (currentScroll >= glossaryBottom) {
            $(".glossary-filters-wr").addClass("is-absolute");
          } else {
            $(".glossary-filters-wr").removeClass("is-absolute");
          }
        });

        // No results message (hacked)
        $(".views-summary-unformatted .no-result", context).on(
          "click",
          function () {
            $(
              ".view-glossary.view-display-id-glossary .views-summary-unformatted a"
            ).removeClass("is-active");
            $(
              ".view-glossary.view-display-id-glossary > .view-content"
            ).addClass("is-hidden");
            $(
              ".view-glossary.view-display-id-glossary > .no-results"
            ).removeClass("is-hidden");

            filtersTop = $(".glossary-filters-wr").offset().top;
            glossaryBottom =
              $(".view-glossary.view-display-id-glossary").offset().top +
              $(".view-glossary.view-display-id-glossary").outerHeight() -
              $(".glossary-filters-wr").outerHeight();
          }
        );

        // Open glossary description
        if (once("matchHeight1", ".glossary-wr .title", context).length) {
          $(".glossary-wr .title", context).on("click", function () {
            $(this).next().slideToggle().parent().toggleClass("is-open");
          });
        }

        // Mobile
        $(".glossary-mobile-wr", context).on("click", function () {
          $(this)
            .toggleClass("is-open")
            .parent()
            .find(".view-content")
            .toggleClass("is-open");
        });

        // Slide to item if on glossary page.
        $(document).ready(function () {
          var glossaryHash;

          if (window.location.href.indexOf("/glossary#") > -1) {
            glossaryHash = window.location.hash;
            var glossaryItemTop =
              $(glossaryHash).offset().top -
              $(".glossary-filters-wr").outerHeight();

            $("html, body", context).animate(
              {
                scrollTop: glossaryItemTop,
              },
              function () {
                if (once("matchHeight2", glossaryHash).length) {
                  $(glossaryHash)
                    .next()
                    .slideToggle()
                    .parent()
                    .toggleClass("is-open");
                }
              }
            );
          }
        });

        /*
         * Get is-active class to the Active letter.
         */
        $(".glossary-filters-wr .view-content .views-summary a", context).on(
          "click",
          function () {
            var letter = $(this).text();
            var parent = $(this).closest(".block-views-blockglossary-glossary");

            if (letter !== "All") {
              parent.addClass("glossary-letter-active");
            } else {
              parent.removeClass("glossary-letter-active");
            }
            parent.attr("data-letter-clicked", letter);
          }
        );

        // This is part of adding the is-active class to Active letter.
        // I have to do this, because the View is replaced after the AJAX is fired.
        $(".glossary-filters-wr .view-content .views-summary a", context).each(
          function () {
            var parentAtrr = $(".block-views-blockglossary-glossary").attr(
              "data-letter-clicked"
            );
            var attr = $(this).attr("data-letter-clicked");

            // For some browsers, `attr` is undefined; for others, 'attr' is false.  Check for both.
            if (typeof attr !== "undefined" && attr !== false) {
              if (parentAtrr === attr) {
                $(this).addClass("is-active");
              }
            }
          }
        );

        // This is part of adding the is-active class to Active letter.
        // Remove the .is-active to the active letter in case someone uses the
        // exposed filter.
        if (
          once("matchHeight3", ".block-views-blockglossary-glossary").length
        ) {
          $(document, context).ajaxComplete(function (event, xhr, aJsettings) {
            if (typeof aJsettings.data !== "undefined") {
              var tileEntered = aJsettings.data.substring(
                0,
                aJsettings.data.indexOf("&")
              );

              if (tileEntered.startsWith("title")) {
                $(
                  ".glossary-filters-wr .view-content .views-summary a"
                ).removeClass("is-active");
                $(".block-views-blockglossary-glossary").removeClass(
                  "glossary-letter-active"
                );
              }
            }
          });
        }

        // Hacked the input exposed filter.
        // There was a problem for iOS devices, because on Enter the page was
        // redirected to /glossary/n?title=copy and because this page was not
        // accessible by anyone except admins, you got a 403 error.
        $(".view-id-glossary .views-exposed-form input").keypress(function (
          event
        ) {
          if (event.which == "13") {
            event.preventDefault();
            // Fill the input with the searched phrase and trigger out of focus,
            // which then triggers the auto submit (AJAX).
            var value = $(this).val();
            $(this).val(value);
            $(this).trigger("blur");
          }
        });
      }
    },
  };

  /*-----------------------------------------
    18. What's new slider
   ----------------------------------------*/
  Drupal.behaviors.whatsNewSlider = {
    attach: function (context, settings) {
      if (once("whatsNewSlider", "#whats-new-slider").length) {
        new Splide("#whats-new-slider", {
          type: "loop",
          perPage: 3,
          perMove: 1,
          start: 1,
          autoplay: true,
          interval: 4000,
          speed: 250,
          flickMaxPages: 1,
          flickPower: 30,
          arrows: false,
          pagination: true,
          drag: true,
          gap: "24px",
          focus: "center",
          trimSpace: true,
          updateOnMove: true,
          breakpoints: {
            991: {
              perPage: 1,
              start: 0,
            },
          },
        }).mount();
      }
    },
  };

  /*-----------------------------------------
    19. Partnerships slider
   ----------------------------------------*/
  Drupal.behaviors.partnershipsSlider = {
    attach: function (context, settings) {
      if (once("partnershipsSlider", "#partnerships-slider").length) {
        new Splide("#partnerships-slider", {
          type: "loop",
          perPage: 1,
          perMove: 1,
          autoplay: true,
          interval: 4000,
          speed: 250,
          arrows: false,
          pagination: true,
          drag: true,
          gap: "24px",
          focus: "center",
          trimSpace: true,
          updateOnMove: true,
        }).mount();
      }
    },
  };

  /*-----------------------------------------
    20. Cookies module changes
   ----------------------------------------*/
  Drupal.behaviors.sgtCookiesBanner = {
    attach: function (context, settings) {
      Drupal.behaviors.igniteCookies.igniteCookies(
        true,
        false,
        110,
        132,
        null,
        context,
        settings
      );

      // Adobe analytics through html is disabled for now.
      // The solution is to listen for the CookiesJSR consent event and load the Adobe analytics script if the consent is given.
      if (once('cookiesBannerForAdobeAnalytics', 'html').length) {
        var loadAdobeLaunch = function () {
          // Prevent loading twice.
          if (window._adobeLaunchLoaded) {
            return;
          }
          window._adobeLaunchLoaded = true;

          var s = document.createElement('script');
          s.src = 'https://assets.adobedtm.com/38122a8967c9/acf93373e716/launch-e49a2bc00cce.min.js';
          s.async = true;
          document.getElementsByTagName('head')[0].appendChild(s);
        };

        var hasAnalyticsConsent = function (detail) {

          if (!detail) {
            return false;
          }

          if (detail.services && detail.services.analytics === true) {
            return true;
          }

          return false;
        };

        // Listen for CookiesJSR consent event.
        document.addEventListener('cookiesjsrUserConsent', function (e) {
          if (hasAnalyticsConsent(e.detail)) {
            loadAdobeLaunch();
          }
        });
      }
    },
  };

  /*-----------------------------------------
      21. Events load more
    ----------------------------------------*/
  Drupal.behaviors.eventsLoadMore = {
    attach: function (context, settings) {
      var $loadMoreBtn = $(".events__load-more-btn", context);

      if (once("eventsLoadMore", $loadMoreBtn).length) {
        $loadMoreBtn.on("click", function (event) {
          event.preventDefault();

          var $button = $(this);
          var $hiddenEvents = $(".event__item--hidden", context);

          $hiddenEvents
            .removeClass("event__item--hidden")
            .addClass("event__item--visible");
          $hiddenEvents.children().addClass("viewport-show");

          // Hide the load more button.
          $button.closest(".events__load-more").fadeOut(300);
        });
      }
    },
  };

})(jQuery);
